<template>
	<div class=" bg-[#F5F7FA]">
		<Header :current="6"></Header>
		<div
			class="2xl:max-w-6xl xl:max-w-6xl lg:container md:container mx-auto py-10 box-border  flex  items-center justify-around">
			<div class="flex flex-col items-center">
				<div class="mb-[16px] text-[22px] font-bold">
					{{langInfo['APP_download']}}
				</div>
				<img :src="download_app_image" class="w-[180px] h-[180px]" alt="" />
			</div>
			<div class="flex flex-col items-center">
				<div class="text-[16px]" v-html="content">
				</div>
				<div @click="downLoadBtn()"
					class="w-[248px] h-[58px] mt-[20px] cursor-pointer mb-[30px] mx-auto leading-[58px] rounded-[50px] bg-[#3894FF] text-center text-white text-[18px] font-bold">
					<i class="el-icon-download text-white text-[22px]"></i> {{langInfo['APP_download']}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
	import emptyPage from '@/components/emptyPage.vue'
	export default {
		components: {
			Header,
			Footer,
			emptyPage
		},
		data() {
			return {

				langInfo: {},
				download_app_image: '',
				content: '',
				system_app: ''
			}
		},
		mounted() {
			this.getdict_data()
			this.getconfig()
			this.agreement()
		},
		methods: {
			agreement() {
				this.$api.agreement({
					mark: 'pc_download_app'
				}).then((res) => {
					console.log(res.data.content);
					this.content = res.data.content

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getconfig() {
				// official_weChat=首页官方微信
				// download_app_image=下载二维码
				this.$api.config({}).then((res) => {
					console.log(res);
					this.download_app_image = res.data.download_app_image
					this.system_app = res.data.system_app

				}).catch((error) => {})
			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					document.title =this.langInfo.pc_name+'-'+ this.langInfo.APP_download;

				}).catch((error) => {})
			},
			downLoadBtn() {
				window.location.href = this.system_app
			}
		},
	}
</script>

<style>
</style>